import { Typography } from "@circle-react-shared/uikit/Typography";

import { ConfirmationModal } from "@/react/components/SettingsApp/CompassCompat/ConfirmationModal";

interface CancelDowngradeScheduleModalProps {
  confirmText: string;
  description: string;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  showModal: boolean;
  title: string;
}
export const CancelDowngradeScheduleModal = ({
  showModal,
  onClose,
  onConfirm,
  title,
  confirmText,
  description,
  isLoading = false,
}: CancelDowngradeScheduleModalProps) => (
  <ConfirmationModal
    isOpen={showModal}
    onClose={onClose}
    confirmVariant="circle"
    size="md"
    onConfirm={onConfirm}
    title={title}
    confirmText={confirmText}
    disabled={isLoading}
  >
    <Typography.LabelMd>{description}</Typography.LabelMd>
  </ConfirmationModal>
);
